import * as React from "react";
import * as ReactDOM from "react-dom";

import CalendarReduxProvider from "../CalendarReduxProvider";

import * as viewModes from "../reducers/viewModes";

// For hot reloading:
declare var module: any;
if (module.hot) {
  module.hot.accept();
}

const TryParseInt = (str: string, defaultValue: number): number => {
  let retValue = defaultValue;
  if (str !== null) {
    if (str.length > 0) {
      if (!isNaN(parseInt(str, 10))) {
        retValue = parseInt(str, 10);
      }
    }
  }
  return retValue;
};

// Doing this with plain old JS (not JQuery) to avoid dependency on JQuery.
const components = document.getElementsByClassName("modernCalendarComponent");

for (let i = 0; i < components.length; i++) { // tslint:disable-line prefer-for-of

  const elem = components[i];

  const action: string = elem.attributes["data-action"].nodeValue;
  const calendarId: number = elem.attributes["data-calendar-id"].nodeValue;
  const contextId: number = elem.attributes["data-context-id"].nodeValue;
  const currentDate: Date = elem.attributes["data-initial-current-date"].nodeValue;
  const displayedEventId: number = TryParseInt(elem.attributes["data-displayed-event-id"].nodeValue, 0);
  const firstDayOfWeek: string = elem.attributes["data-first-day-of-week"].nodeValue;
  const headerAndBorderColor: string = elem.attributes["data-header-and-border-color"].nodeValue;
  const pageId: number = elem.attributes["data-page-id"].nodeValue;
  const pageName: string = elem.attributes["data-page-name"].nodeValue;
  const parentId: number = elem.attributes["data-parent-id"].nodeValue;
  const portalId: number = elem.attributes["data-portal-id"].nodeValue;
  const portletInstanceId: number = elem.attributes["data-portlet-instance-id"].nodeValue;
  const selectedColor: string = elem.attributes["data-selected-color"].nodeValue;
  const todayColor: string = elem.attributes["data-today-color"].nodeValue;
  const todaysDate: Date = elem.attributes["data-todays-date"].nodeValue;
  const viewMode: string = viewModes.ConvertToStandardViewMode(elem.attributes["data-initial-view-mode"].nodeValue);

  const render = (Component) => {
    ReactDOM.render(
      <Component
        action={action}
        calendarId={calendarId}
        contextId={contextId}
        currentDate={currentDate}
        displayedEventId={displayedEventId}
        firstDayOfWeek={firstDayOfWeek}
        headerAndBorderColor={headerAndBorderColor}
        pageId={pageId}
        pageName={pageName}
        parentId={parentId}
        portalId={portalId}
        portletInstanceId={portletInstanceId}
        selectedDateColor={selectedColor}
        todayColor={todayColor}
        todaysDate={todaysDate}
        viewMode={viewMode}
      />,
      elem,
    );
  };

  render(CalendarReduxProvider);
}
